/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyDto } from '../../models/api-key-dto';
import { ApiKeys } from '../../models/api-keys';

export interface ApiKeysCreateKey$Params {
      body: ApiKeyDto
}

export function apiKeysCreateKey(http: HttpClient, rootUrl: string, params: ApiKeysCreateKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeys>> {
  const rb = new RequestBuilder(rootUrl, apiKeysCreateKey.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeys>;
    })
  );
}

apiKeysCreateKey.PATH = '/api/ApiKeys';
